import * as React from 'react';
import {observer} from 'mobx-react';
import {resetAnchorStyles} from '../theme/reset';
import {style} from 'typestyle';
import {colorBrand} from '../theme/color';
import {Highlight} from './highlight';
import {ArtistSchema} from '../types/schema';

export interface ArtistLinkListModel {
  artists: Array<Pick<ArtistSchema, 'name' | 'slug' | 'highlight'>>;
}

export interface ArtistLinkListProps {
  model: ArtistLinkListModel;
  className?: string;
  linkClassName?: string;
  containerStyle?: any;
  highlight?: string;
  onClickLink(event: React.MouseEvent<any>): void;
}

export const ArtistLinkListLinkStyle = style({
  textDecoration: 'underline',
  color: colorBrand.toString(),
  $nest: { ...resetAnchorStyles(colorBrand.toString()) }
});

const DEFAULT_MODEL = {
  artists: []
};

@observer
export class ArtistLinkList extends React.Component<ArtistLinkListProps, {}> {
  render() {
    const { model = DEFAULT_MODEL, highlight, onClickLink, containerStyle = {}, className, linkClassName } = this.props;

    return (
      <div style={containerStyle} className={className}>
        {model.artists.reduce((acc, artist, index) => {
          if (index + 1 < model.artists.length) return [ ...acc, artist, null];
          return [ ...acc, artist ]
        }, []).map((artist, index) => {
          if (artist === null) return (<span key={index}>, </span>);

          const highlightName = artist.highlight && artist.highlight.length
            && artist.highlight.find(h => h.key === 'name');

          return (
            <a
              title={artist.name}
              key={index}
              className={linkClassName || ArtistLinkListLinkStyle}
              href={`/music/artists/${artist.slug}`}
              onClick={onClickLink}
            >
              <Highlight innerHtml={highlightName ? highlightName.value : void 0} match={highlight}>{artist.name}</Highlight>
            </a>
          );
        })}
      </div>
    )

  }
}